import React from 'react';
import PropTypes from 'prop-types';
import Text from 'relements/build/esm/input/text';

import Icon from '@src/components/Icon';
import './ObjectInput.scss';

export default class ObjectInput extends React.Component {
  state = {
    rows: [],
  };

  componentDidMount() {
    if (this.props.value) {
      this.setState({
        rows: Object.keys(this.props.value).map(key => ({
          key,
          value: this.props.value[key],
        })),
      });
    }
  }

  render() {
    return (
      <div className="object-input">
        <div className="object-input-title">{this.props.label}</div>
        {this.state.rows.map((row, i) => {
          return (
            <div key={i} className="object-input-row">
              <Text
                value={row.key}
                onChange={this._handleChange(i, 'key')}
                placeholder="key"
              />
              <Text
                value={row.value}
                onChange={this._handleChange(i, 'value')}
                placeholder="value"
              />
              <Icon onClick={this._deleteRow(i)} iconType="trash" />
            </div>
          );
        })}
        <div onClick={this._addRow} className="object-input-add">
          <Icon iconType="plus" /> Add another row
        </div>
      </div>
    );
  }

  _handleChange = (index, key) => value => {
    const {rows} = this.state;
    rows[index][key] = value;
    this.setState({ rows });

    const normalizedData = {};
    rows.forEach(row => {
      normalizedData[row.key] = row.value;
    });

    this.props.onChange(normalizedData);
  };

  _addRow = () => {
    let {rows} = this.state;
    rows = this.state.rows.concat({
      key: '',
      value: '',
    });

    this.setState({ rows });
  };

  _deleteRow = indexToRemove => () => {
    let {rows} = this.state;
    rows = [...rows.slice(0, indexToRemove), ...rows.slice(indexToRemove + 1)];
    this.setState({ rows });
  };
}

ObjectInput.propTypes = {
  businessId: PropTypes.number,
  activateLoader: PropTypes.func,
  deactivateLoader: PropTypes.func,
};
